import { NavLink, Link } from "react-router-dom";
import { Home, BookCheck, BarChart3, User, HardHat, Layers } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LevelBadge } from "@/components/LevelBadge";
import { ThemeToggle } from "@/components/ThemeToggle";
import "@/components/ChantierMode";
import { useDailyReminder } from "@/lib/reminder";
import { useOfflineSync } from "@/lib/useOfflineSync";
import { OfflineBanner } from "@/components/OfflineBanner";

const NAV = [
  { to: "/", label: "Accueil", icon: Home, id: "nav-home-btn" },
  { to: "/lecons", label: "Leçons", icon: BookCheck, id: "nav-lessons-btn" },
  { to: "/vocabulaire", label: "Mots", icon: Layers, id: "nav-vocab-btn" },
  { to: "/progression", label: "Progrès", icon: BarChart3, id: "nav-progress-btn" },
  { to: "/profil", label: "Profil", icon: User, id: "nav-profile-btn" },
];

export function Layout({ children }) {
  const { user, refresh } = useAuth();
  useDailyReminder();
  useOfflineSync(refresh);
  return (
    <div className="min-h-screen pb-24 print:pb-0 print:bg-white">
      <header className="sticky top-0 z-30 bg-slate-900 text-white print:hidden">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2" data-testid="header-logo-link">
            <span className="w-8 h-8 rounded-md bg-orange-500 grid place-items-center">
              <HardHat className="w-5 h-5 text-slate-900" />
            </span>
            <span className="font-display text-xl font-bold uppercase">Français Chantier</span>
          </Link>
          {user && (
            <div className="flex items-center gap-2">
              <LevelBadge level={user.level} testId="header-level-badge" dark />
              <ThemeToggle />
            </div>
          )}
        </div>
        <div className="hazard-stripe h-1.5" />
      </header>
      <OfflineBanner />
      <main className="max-w-3xl mx-auto px-4 py-6">{children}</main>
      <nav className="fixed bottom-0 inset-x-0 z-30 bg-white border-t-2 border-slate-200 print:hidden">
        <div className="max-w-3xl mx-auto grid grid-cols-5">
          {NAV.map(({ to, label, icon: Icon, id }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={id}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-3 text-[11px] font-bold uppercase tracking-wide transition-colors ${
                  isActive ? "text-orange-600" : "text-slate-500 hover:text-slate-900"
                }`
              }
            >
              <Icon className="w-6 h-6" />
              {label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
